<template>
  <div v-loading="showFlag">
    <t-card class="card_common">
      <div :style="{ height: basicHeight + 'px' }">
        <t-form :model="searchConditionForm" inline label-width="110px">
          <!-- 年月 -->
          <t-form-item :label="$t('resource.utilizeSet.exrMonth')">
            <!--日付 -->
            <t-date-picker
              v-model="searchConditionForm.exrDate"
              :clearable="false"
              type="month"
              :placeholder="$t('resource.sys.hidden')"
              value-format="yyyy/MM"
              @change="clearList"
            >
            </t-date-picker>
          </t-form-item>

          <!--貨幣タイプ -->
          <t-form-item label="" style="width: 100px">
            <t-select
              v-model="searchConditionForm.exrCurType"
              @change="clearList"
            >
              <t-option value="CNY" label="CNY"></t-option>
              <t-option value="USD" label="USD"></t-option>
              <t-option value="THB" label="THB"></t-option>
            </t-select>
          </t-form-item>
          <t-form-item>
            <div
              class="el-icon-arrow-right"
              style="align-items: center; justify-content: center"
            ></div>
          </t-form-item>

          <t-form-item style="width: 100px">
            <t-input placeholder="JP￥" :disabled="true"></t-input>
          </t-form-item>
          <t-form-item>
            <!--検索 -->
            <t-button
              round
              type="primary"
              class="button_common_search"
              ref="searchBtn"
              @click="searchClick()"
            >
              <i class="el-icon-search"></i>{{ $t("resource.sys.search") }}
            </t-button>
          </t-form-item>
        </t-form>
      </div>
      <div style="padding: 0 0 20px 60px; width: 60%">
        <t-table
          :height="detailHeight"
          class="table_common"
          header-cell-class-name="bg-default"
          :data="tableData"
          border
        >
          <!-- 日付 -->
          <t-table-column
            :label="$t('resource.utilizeSet.exrDate')"
            prop="exrDate"
            header-align="center"
            class-name="cell_txt_center"
          ></t-table-column>
          <!--レート -->
          <t-table-column
            :label="$t('resource.utilizeSet.exrRate')"
            prop="exrRate"
            header-align="center"
            class-name="cell_txt_center"
          >
            <template slot-scope="scope">
              <t-input-number
                :controls="false"
                :precision="2"
                :min="0"
                :max="999.99"
                v-model="scope.row.exrRate"
              ></t-input-number>
            </template>
          </t-table-column>
        </t-table>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <!-- 確定 -->
        <div style="text-align: right">
          <t-button
            round
            type="warning"
            class="dialogButton_confirm_120_40"
            ref="confirmBtn"
            @click="confirm()"
          >
            <i class="el-icon-check"></i>
            {{ $t("resource.COMMON_CONSTANT.CONFIRM") }}</t-button
          >
        </div>
      </div>
    </t-card>
  </div>
</template>

<script>
import { getUserInfo } from "@/auth";
import { t } from "@/locales";
import {
  SearchExchangeRateData,
  UpdateExchangeRateData,
} from "@/services/documentSet";
import {
  getDialogContentHeight,
  getEditColWidthArr,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT } from "@/utils/const";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //maxheight: window.innerHeight - 291.5 - 10,
      //検索条件
      searchConditionForm: {
        exrDate: "", // 年月
        exrCurType: "CNY",
      },

      updateTime: "", //更新時間

      tableData: [],
      showFlag: false,

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 1,
      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        0,
        30
      ),
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,
    };
  },
  mounted() {
    //画面初期化
    this.init();
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        0,
        30
      );

      this.colArr = getEditColWidthArr(window.innerWidth, 4);
    },
    // 画面初期化
    init() {
      this.dateInit();
    },

    //日付初期化
    dateInit() {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      this.searchConditionForm.exrDate = `${year}/${month}`;

      this.searchClick();
    },

    // 検索
    searchClick() {
      // フォーカス削除
      this.$refs.searchBtn.$el.blur();

      this.showFlag = true;

      SearchExchangeRateData({
        selectYearMonth: this.searchConditionForm.exrDate,
        selectExrCurType: this.searchConditionForm.exrCurType,
      })
        .then((res) => {
          this.searchYearMonthData();

          let rateData = res.exchangeRateList;

          this.updateTime = res.updateTime;

          //if (rateData.length > 0) {
          for (let i = 0; i < rateData.length; i++) {
            for (let j = 0; j < this.tableData.length; j++) {
              if (rateData[i].exrDate == this.tableData[j].exrDate) {
                this.tableData[j].exrRate = rateData[i].exrRate;
                break;
              }
            }
          }
          //}

          // Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
        })
        .catch((err) => {
          this.showFlag = false;
          Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    searchYearMonthData() {
      this.tableData = [];
      let year = "";
      let month = "";
      if (this.searchConditionForm.exrDate) {
        let dateArr = this.searchConditionForm.exrDate.split("/");
        year = dateArr[0];
        month = dateArr[1];
      }
      const daysOfMonth = [];
      month = parseInt(month, 10);
      const lastDayOfMonth = new Date(year, month, 0).getDate();

      let strMonth = month;
      if (month < 10) {
        strMonth = "0" + strMonth;
      }
      for (let i = 1; i <= lastDayOfMonth; i++) {
        if (i < 10) {
          this.tableData.push({
            exrDate: year + "/" + strMonth + "/" + "0" + i,
            exrRate: undefined,
          });
        } else {
          this.tableData.push({
            exrDate: year + "/" + strMonth + "/" + i,
            exrRate: undefined,
          });
        }
      }
    },

    // 編集
    confirm() {
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();

      if (this.tableData.length == 0) {
        Modal.showWarning("", t("message.COMMON_MESSAGE.DATE_INPUT_MSG"));
        return;
      }

      this.showFlag = true;

      UpdateExchangeRateData({
        loginUser: getUserInfo().UserId,
        updateTime: this.updateTime,
        selectYearMonth: this.searchConditionForm.exrDate,
        selectExrCurType: this.searchConditionForm.exrCurType,
        exchangeRateList: this.tableData,
      })
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));

          this.searchClick();
        })
        .catch((err) => {
          Message.showError(
            t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
          );
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    clearList() {
      this.tableData = [];
      this.searchClick();
    },
  },
};
</script>

<style scoped lang="scss">
/*.div_search {
  width: 100%;
  display: inline-block;
  // border: 1px solid #dddcdc;
  margin-left: 10px;
}*/
.arrow-icon {
  text-align: center;
  padding: 10px;
}
</style>
<style lang="scss">
.table-input {
  input {
    border: none;
  }
}
</style>
